import React, { useState, useEffect, useCallback, useContext } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'
import DatePicker, { CalendarContainer } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { AppColors } from '../css/AppColors';
import { Modal, Button } from 'react-bootstrap';
import { apiRequest } from '../utils/apiCalls';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { Context } from '../Context/DataContext';
import { useHistory, useLocation } from 'react-router';
import { Link } from 'react-router-dom';
// import { reactLocalStorage } from 'reactjs-localstorage';



const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return useCallback(() => updateState({}), []);
}



const EditCustomer = () => {


    const forceUpdate = useForceUpdate()
    const history = useHistory();
    var location = useLocation();
    const [startDate, setStartDate] = useState(new Date());

    const { state, setCustomersGlobal } = useContext(Context)


    const [loading, setLoading] = useState(false)

    // const { cust_id, cust_fname, cust_lname, cust_dob, cust_phone, h_phone,
    //     cust_email, cust_address, cust_best_contact, st_id } = location?.state ? location.state :
    // location.state.cust_id = '';
    // cust_fname = '';
    // cust_lname = '';
    // cust_dob = '';
    // cust_phone = '';
    // h_phone = '';
    // cust_email = '';
    // cust_address = '';
    // cust_best_contact = '';
    // st_id = ''

    const [userData, setUserData] = useState({
        cust_fname: location?.state.cust_fname ? location?.state.cust_fname : '',
        cust_lname: location?.state.cust_lname ? location?.state.cust_lname : '',
        cust_dob: location?.state.cust_dob ? location?.state.cust_dob : new Date(),
        cust_phone: location?.state.cust_phone ? location?.state.cust_phone : '',
        cust_email: location?.state.cust_email ? location?.state.cust_email : '',
        cust_address: location?.state.cust_address ? location?.state.cust_address : '',
        cust_best_contact: location?.state.cust_best_contact ? location?.state.cust_best_contact : '',
        st_id: state.storeData.st_id,
        h_phone: location?.state?.h_phone ? location?.state.h_phone : '',
        cust_id: location?.state?.cust_id ? location?.state.cust_id : ''
    })
    const [selectedDate, setSelectedDate] = useState(userData.cust_dob ? new Date(userData.cust_dob) : new Date())





    function addCust() {

        if (userData.cust_fname == '') {
            alert('Please enter a first name')
            return
        }
        if (userData.cust_lname == '') {
            alert('Please enter a last name')
            return
        }
        if (userData.cust_dob == '') {
            alert('Please enter date of birth')
            return
        }
        if (userData.cust_phone == '') {
            alert('Please enter a valid phone')
            return
        }
        if (userData.cust_email == '') {
            alert('Please enter a valid email')
            return
        }
        if (userData.cust_address == '') {
            alert('Please enter customer address')
            return
        }
        if (userData.cust_best_contact == '') {
            alert('Please select customer best contact')
            return
        }
        if (!userData.cust_id) {
            alert('cust_is missing')
            return
        }


        setLoading(true)

        apiRequest(userData, 'editcust')
            .then(data => {
                setLoading(false)
                console.log(data)
                if (data.status == 1) {
                    // alert('Customer Updated')
                    if (data.customers) {
                        setCustomersGlobal(data.customers)
                    }
                    history.replace('/viewCustomers')
                }
                else {
                    alert(data.error)
                }
            })
            .catch(err => {
                setLoading(false)
                // console.log(err)
                alert('Internet Error')
            })



    }

    useEffect(() => {
        if (!location.state.cust_id) {
            history.push('addCustomer')
            return
        }
    }, [])

    return (
        <div id="page-top">
            <div id="wrapper" >
                <Sidebar />
                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />


                        <div className="container-fluid" >


                            <Modal
                                show={loading}
                                onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>
                            {/* Page Wrapper */}
                            <div id="wrapper" >
                                {/* Content Wrapper */}
                                <div id="content-wrapper" className="d-flex flex-column" style={{ paddingBottom: 200 }} >
                                    {/* Main Content */}
                                    <div id="content">
                                        {/* Begin Page Content */}
                                        <div className="container-fluid">
                                            {/* Page Heading */}
                                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                                <h1 className="h3 mb-0 text-gray-800">Edit Customer</h1>
                                            </div>
                                            <div className="row">
                                                {/* <form id="frm_customer"> */}
                                                <input
                                                    type="hidden"
                                                    name="g_name"
                                                    className="form-control form-control-user"
                                                    placeholder="From - Garage name"
                                                />
                                                <input
                                                    type="hidden"
                                                    name="g_phone"
                                                    className="form-control form-control-user"
                                                    placeholder="From - Garage phone"
                                                />
                                                <input
                                                    type="hidden"
                                                    name="g_email"
                                                    className="form-control form-control-user"
                                                    placeholder="From - Garage email"
                                                />

                                                <div className="form-group row">
                                                    <div className="col-sm-6">
                                                        <div className="editDetails" >First Name</div>
                                                        <input
                                                            type="text"
                                                            name="cust_fname"
                                                            id="cust_fname"
                                                            className="form-control form-control-user"
                                                            placeholder="First Name"
                                                            value={userData.cust_fname}
                                                            onChange={(t) => {
                                                                setUserData({
                                                                    ...userData,
                                                                    cust_fname: t.target.value
                                                                })
                                                            }}

                                                        />
                                                        <br />
                                                    </div>
                                                    <div className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >Last Name</div>
                                                        <input
                                                            type="text"
                                                            name="cust_lname"
                                                            id="cust_lname"
                                                            className="form-control form-control-user"
                                                            placeholder="Last Name"
                                                            value={userData.cust_lname}
                                                            onChange={(t) => {
                                                                setUserData({
                                                                    ...userData,
                                                                    cust_lname: t.target.value
                                                                })
                                                            }}
                                                        />
                                                        <br />
                                                    </div>
                                                    <div
                                                        className="col-sm-6 mb-3 mb-sm-0"
                                                    >
                                                        <div className="editDetails" >DOB</div>
                                                        <DatePicker
                                                            className="form-control form-control-user"
                                                            // calendarContainer={MyContainer}
                                                            // showTimeSelect={true}
                                                            // dateFormat="Pp"
                                                            // dateFormatCalendar="yyyy-mm-dd"
                                                            value={userData.cust_dob}
                                                            selected={selectedDate}
                                                            onChange={(date) => {
                                                                console.log(date)
                                                                setSelectedDate(date)
                                                                setUserData({
                                                                    ...userData,
                                                                    cust_dob: date
                                                                })

                                                            }} />
                                                        {/* <input name="cust_dob" id="cust_dob" placeholder="DOB" /> */}
                                                        <br />
                                                    </div>
                                                    <div id="div_own_email" className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >C-Phone</div>
                                                        <input
                                                            type="text"
                                                            name="cust_phone"
                                                            id="cust_phone"
                                                            className="form-control form-control-user"
                                                            placeholder="C-Phone"
                                                            value={userData.cust_phone}
                                                            onChange={(t) => {
                                                                setUserData({
                                                                    ...userData,
                                                                    cust_phone: t.target.value
                                                                })
                                                            }}
                                                        />
                                                        <br />
                                                    </div>
                                                    <div id="div_own_email" className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >H-Phone</div>
                                                        <input
                                                            type="number"
                                                            name="H-Phone"
                                                            id="H-Phone"
                                                            className="form-control form-control-user"
                                                            placeholder="H-Phone"
                                                            value={userData.h_phone}
                                                            onChange={(t) => {
                                                                setUserData({
                                                                    ...userData,
                                                                    h_phone: t.target.value
                                                                })
                                                            }}
                                                        />
                                                        <br />
                                                    </div>
                                                    <div id="div_own_phone" className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >Email</div>
                                                        <input
                                                            type="text"
                                                            name="cust_email"
                                                            id="cust_email"
                                                            className="form-control form-control-user"
                                                            placeholder="Email"
                                                            value={userData.cust_email}
                                                            onChange={(t) => {
                                                                setUserData({
                                                                    ...userData,
                                                                    cust_email: t.target.value
                                                                })
                                                            }}
                                                        />
                                                        <br />
                                                    </div>

                                                    <div className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >Address</div>
                                                        <input
                                                            type="text"
                                                            name="cust_address"
                                                            id="cust_address"
                                                            className="form-control form-control-user"
                                                            placeholder="Address"
                                                            value={userData.cust_address}
                                                            onChange={(t) => {
                                                                setUserData({
                                                                    ...userData,
                                                                    cust_address: t.target.value
                                                                })
                                                            }}
                                                        />
                                                        <br />
                                                    </div>
                                                    {/* <div className="col-sm-6 mb-3 mb-sm-0">
                                                        <select
                                                            name="cust_status"
                                                            id="cust_status"
                                                            className="form-control form-control-user"
                                                            placeholder="Status"
                                                        >
                                                            <option value selected disabled>
                                                                Status
                                                            </option>
                                                            <option value={1}>Active</option>
                                                            <option value={0}>Inactive</option>
                                                        </select>
                                                        <br />
                                                    </div> */}
                                                    <div className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >Best Contact</div>
                                                        <select
                                                            name="cust_best_contact"
                                                            id="cust_best_contact"
                                                            className="form-control form-control-user"
                                                            placeholder="Best Contact"
                                                            value={userData.cust_best_contact}
                                                            onChange={(t) => {
                                                                setUserData({
                                                                    ...userData,
                                                                    cust_best_contact: t.target.value
                                                                })
                                                            }}

                                                        >
                                                            <option value selected disabled>
                                                                Best Contact
                                                            </option>
                                                            <option value="phone">Phone</option>
                                                            <option value="SMS">SMS</option>
                                                            <option value="email">Email</option>
                                                        </select>
                                                        <br />
                                                    </div>
                                                </div>
                                                <Button
                                                    id="add_customer"
                                                    className="btn btn-primary btn-user btn-block"
                                                    onClick={() => addCust()}
                                                    style={{ backgroundColor: AppColors.primary, borderWidth: 0, fontFamily: 'RBo' }}
                                                >
                                                    Save
                                                </Button>
                                                {/* </form> */}
                                            </div>
                                        </div>
                                        {/* /.container-fluid */}
                                    </div>
                                    {/* End of Main Content */}
                                </div>
                                {/* End of Content Wrapper */}
                            </div>
                            {/* End of Page Wrapper */}
                            {/* Scroll to Top Button*/}
                            <a className="scroll-to-top rounded" href="#page-top">
                                <i className="fas fa-angle-up" />
                            </a>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditCustomer
